<template>
    <div id="banner" :class="{'home-banner':isHome}">
        <div class="banner-img" :style="bgImageStyle">
            <template v-if="isHome">
                <!--博主信息-->
                <div class="focusinfo">
                    <!-- 头像 -->
                    <div class="header-tou">
                        <router-link to="/">
                            <cached-image :src="websiteInfo.avatar" :style="{width: '80px', height: 'auto', 'border-radius': '50%', border: '3px solid rgba(255, 255, 255, 0.3)'}" />
                        </router-link>
                    </div>
                    <!-- 简介 -->
                    <div class="header-info">
                        <p>{{websiteInfo.slogan}}</p>
                    </div>
                    <!-- 社交信息 -->
                    <div class="top-social">
                        <div v-for="item in socials" :key="item.id" :title="item.title"><a :href="item.href" target="_blank" :style="{'color':item.color}"><i class="iconfont" :class="item.icon"></i></a></div>
                    </div>
                </div>
                <!--左右倾斜-->
                <div class="slant-left"></div>
                <div class="slant-right"></div>
            </template>
        </div>
    </div>
</template>

<script>
    import CachedImage from '@/components/cached-image'
    import { getCachedImage } from '@/utils/request'
    export default {
        name: "banner",
        components: {
            CachedImage
        },
        data(){
            return{
                cachedBgImage: '',
                bgImageStyle: {}
            }
        },
        props:{
            src:{
                type: String,
                default: ''
            },
            isHome:{
                type: [Boolean,String],
                default: false
            }
        },
        computed: {
            websiteInfo() {
                // 优先从 systemInfo 读取（整合接口），其次从 websiteInfo 读取
                if (this.$store.state.systemInfo) {
                    return this.$store.state.systemInfo;
                }
                return this.$store.state.websiteInfo || {};
            },
            socials() {
                // 优先从 systemIcons 读取（整合接口），其次从 socials 读取
                if (this.$store.state.systemIcons && this.$store.state.systemIcons.length > 0) {
                    return this.$store.state.systemIcons;
                }
                return this.$store.state.socials || [];
            },
            // 获取原始背景图 URL
            rawBgImage() {
                if (this.src) {
                    return this.src
                }
                const info = this.websiteInfo
                return info.background || ''
            }
        },
        watch: {
            rawBgImage: {
                immediate: true,
                handler(newBg) {
                    if (newBg && newBg !== '') {
                        this.loadBackground(newBg)
                    } else {
                        this.bgImageStyle = {}
                    }
                }
            }
        },
        created(){
            // 如果没有数据才调用 API（数据会更新到 vuex，计算属性会自动响应）
            if (!this.$store.state.systemInfo && !this.$store.state.websiteInfo) {
                this.getWebSiteInfo();
            }
            if (!this.$store.state.systemIcons || this.$store.state.systemIcons.length === 0) {
                this.getSocial();
            }
        },
        methods:{
            async loadBackground(imageUrl) {
                if (!imageUrl || imageUrl === '') return
                try {
                    const base64 = await getCachedImage(imageUrl)
                    if (base64 && base64 !== '') {
                        this.cachedBgImage = base64
                        // 只有缓存加载完成后才设置背景图样式
                        this.bgImageStyle = {'background-image': `url(${base64})`}
                    }
                } catch (error) {
                    console.error('加载背景图失败:', error)
                    // 加载失败时使用原图
                    this.bgImageStyle = {'background-image': `url(${imageUrl})`}
                }
            },
            getSocial(){
                this.$store.dispatch('getSocials');
            },
            getWebSiteInfo(){
                this.$store.dispatch('getSiteInfo');
            }
        }
    }
</script>

<style scoped lang="less">

    #banner {
        position: relative;
        margin-top: 80px;
        width: 100%;
        height: 500px;
        .banner-img{
            width: inherit;
            height: inherit;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            transition: all 0.2s linear;
            overflow: hidden;
            &:hover {
                transform: scale(1.1, 1.1);
                filter: contrast(130%);
            }
        }
        &.home-banner {
            height: 550px;
            .banner-img{
                background-position: center center;
                background-repeat: no-repeat;
                background-attachment: fixed;
                background-size: cover;
                z-index: -1;
                transition: unset;
                &:hover {
                    transform: unset;
                    filter: unset;
                }
            }
            .slant-left {
                content: '';
                position: absolute;
                width: 0;
                height: 0;
                border-bottom: 100px solid #FFF;
                border-right: 800px solid transparent;
                left: 0;
                bottom: 0;
            }
            .slant-right {
                content: '';
                position: absolute;
                width: 0;
                height: 0;
                border-bottom: 100px solid #FFF;
                border-left: 800px solid transparent;
                right: 0;
                bottom: 0;
            }
        }
    }
    .focusinfo {
        position: relative;
        max-width: 800px;
        padding: 0 10px;
        top: 40%;
        left: 50%;
        transform: translate(-50%,-50%);
        -webkit-transform: translate(-50%,-50%);
        text-align: center;
        .header-info {
            width: 60%;
            font-size: 14px;
            color: #EAEADF;
            background: rgba(0, 0, 0, 0.66);
            padding: 20px 30px;
            margin: 30px auto 0 auto;
            font-family: miranafont,"Hiragino Sans GB",STXihei,"Microsoft YaHei",SimSun,sans-serif;
            letter-spacing: 1px;
            line-height: 30px;
        }
        .top-social {
            height: 32px;
            margin-top: 30px;
            margin-left: 10px;
            list-style: none;
            display: inline-block;
            font-family: miranafont,"Hiragino Sans GB",STXihei,"Microsoft YaHei",SimSun,sans-serif;
            div {
                float: left;
                margin-right: 10px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                width: 32px;
                background: white;
                border-radius: 100%;
            }
        }
    }
    @media (max-width: 960px){
        #banner {height: 400px;}
    }
    @media (max-width: 800px){
        #banner {display: none;}
    }
</style>
